import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { isMobile } from "../../../../../common/parameters";

import { amazonHost } from "../../../../paths";
import Icon from "../../../../icon";
import routing from "../../../../routing";
import Button from "../../../../components/BigWhiteButton";

import {
    StyledHero,
    Background,
    HeroContent,
    LaunchContainer,
    ToEducation,
    ButtonWrapper,
} from "./styles";
import messages from "./messages";
import { useUser } from "../../../../store/user/selectors";

const Hero = () => {
    const [scrollTop, setScrollTop] = useState(0);
    useEffect(() => {
        if (!isMobile) {
            window.addEventListener("scroll", onScroll);
        }
        return () => {
            window.removeEventListener("scroll", onScroll);
        }
    }, []);
    const onScroll = () => {
        const doc = document.documentElement;
        setScrollTop((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0));
    };

    const user = useUser();

    return (
        <StyledHero>
            <Background
                style={{
                    backgroundImage: `url(${amazonHost + "landing/memory-hero.jpg"})`,
                    transform: `translate3d(0, ${scrollTop / 3}px, 0)`,
                }}
            ></Background>
            <HeroContent>
                <h1>
                    <FormattedMessage {...messages.h1} />
                </h1>
                <h2>
                    <FormattedMessage {...messages.h2} />
                </h2>
                <ButtonWrapper>
                    <Link
                        to={
                            "/" +
                            routing.memory +
                            "/" +
                            (!user ? routing.signup : user.loggedIn ? routing.choirs : routing.signup)
                        }
                    >
                        <Button className={cn("button--pretty", "button")}>
                            <FormattedMessage {...messages.start} />
                        </Button>
                    </Link>
                </ButtonWrapper>
                <div>
                    <LaunchContainer>
                        <FormattedMessage {...messages.carousel1Title} />
                    </LaunchContainer>
                </div>
                <ToEducation href="/">
                    <FormattedMessage {...messages.toClassroomEducation} /> <Icon i="arrowback" />
                </ToEducation>
            </HeroContent>
        </StyledHero>
    );
}

export default Hero;
